var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"topBar"}},[_c('div',{staticClass:"flex list"},[_c('div',{staticClass:"back",on:{"click":_vm.goBack}},[_c('van-icon',{attrs:{"name":"arrow-left"}})],1),_c('div',{staticClass:"info flex-item"},[_vm._t("default")],2),_c('div',{staticClass:"more"},[_c('van-icon',{attrs:{"name":"ellipsis"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }